<div class="appointment-booking-wizard-error" data-testid="<%= testIds.booking.fatalError %>">
  <h1 class="completion-message-heading">
    <% if (booking.error_messages.verify_id_session_id_invalid_answers) { %>
      <% help_phone_number = I18n.experian_precise_id_help_number || I18n.help_phone_number %>
      <%= I18n.errors.fatal.identity_title %>
    <% } else { %>
      <% help_phone_number = I18n.help_phone_number %>
      <%= I18n.errors.fatal.unexpected_title %>
    <% } %>
  </h1>

  <div class="appointment-booking-wizard-callout borderless">
    <div class="message message-warning">
      <% if (booking.error_messages.verify_id_session_id_invalid_answers) { %>
        <p>
          <%= booking.error_messages.verify_id_session_id_invalid_answers %>
        </p>
      <% } else { %>
        <p>
          <%= I18n.errors.fatal.unexpected_message %>
        </p>
      <% } %>
      <p>
        <%= I18n.errors.fatal.call_us_html.replaceAll('%{phone_number}', help_phone_number) %>
        <% if (booking.validated_address && booking.validated_address.phone_number) { %>
          <%= I18n.errors.fatal.call_office_html.replaceAll('%{phone_number}', booking.validated_address.phone_number) %>
        <% } %>
      </p>
    </div>
  </div>
</div>
